import { render, staticRenderFns } from "./mySnailBookList.vue?vue&type=template&id=72d20f0f&scoped=true&"
import script from "./mySnailBookList.vue?vue&type=script&lang=js&"
export * from "./mySnailBookList.vue?vue&type=script&lang=js&"
import style0 from "./mySnailBookList.vue?vue&type=style&index=0&id=72d20f0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d20f0f",
  null
  
)

export default component.exports